var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3546 8.5922C3.922 8.2833 3.8783 7.6845 4.2617 7.3222L4.3411 7.2472C4.6499 6.9555 5.1367 6.9174 5.4921 7.1572L10.0282 10.8673L14.5079 7.1573C14.8633 6.9175 15.3501 6.9555 15.6589 7.2473L15.7383 7.3223C16.1218 7.6845 16.078 8.2833 15.6454 8.5923L10.567 12.8292C10.2482 13.0569 9.8081 13.0569 9.4894 12.8292L4.3546 8.5922Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow_down_icon.0a40f59bcd13554959ca482e022c501e.svg";
export { ForwardRef as ReactComponent };